// Abu Dhabi - weight loss personal trainer.
const content = {
    slug: 'weight-loss-personal-trainer',
    title: 'Weight Loss Personal Trainer in Abu Dhabi | Home Coaching',
    description: (c) =>
        `Weight loss personal training in Abu Dhabi at home: strength sessions, daily movement targets and eating habits that fit family life. From ${c.money(c.lowest, 0)} a session.`,
    eyebrow: 'Abu Dhabi · Weight loss',
    h1: 'Weight Loss Personal Trainer in Abu Dhabi',
    lead: 'Big family meals, long drives between home and work, and summers spent indoors - the realities of losing weight in Abu Dhabi. A trainer plans around them instead of pretending they are not there.',
    image: 'blog/health+and+fitness/Functional-training.webp',
    imageAlt: 'Functional training session for weight loss',
    facts: ['Strength plus steps', 'Family-friendly eating', 'Home sessions'],
    ctaLabel: 'Start losing weight',
    matchSummary: 'a weight loss personal trainer in Abu Dhabi',
    packagesTitle: 'Packages for weight loss',
    packagesIntro: 'Three sessions a week for the first two months gets results moving; the 30 or 50-session packages cover that.',
    sections: [
        {
            title: 'Three things that make the difference',
            steps: [
                { title: 'Keep the muscle', body: 'Resistance training two to three times a week, so the weight you lose is fat, not muscle.' },
                { title: 'Move more on non-training days', body: 'A daily step target that works in Abu Dhabi: mall walks or a treadmill in summer, the Corniche or a community park in winter.' },
                { title: 'Eat for the long run', body: 'No banned foods. Portion habits for family meals, protein at every meal, and fewer sugary drinks.' },
            ],
        },
        {
            title: 'For the whole family',
            tone: 'muted',
            paragraphs: [
                'Weight loss is easier when the household is on board. Many Abu Dhabi clients train with a spouse or sibling on the partner rate, and the trainer\'s eating guidance becomes the family\'s way of eating rather than a separate diet.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How many sessions a week do I need to lose weight?',
            answer: 'Two to three trainer sessions a week, plus daily walking. Your trainer adjusts after the first month based on progress.',
        },
        {
            question: 'Can I train during Ramadan?',
            answer: 'Yes - sessions move to just before Iftar or later in the evening, and intensity drops while fasting.',
        },
        {
            question: 'Do I need equipment at home?',
            answer: 'No, the trainer brings portable equipment. If you want a home gym, they can advise what to buy.',
        },
    ],
    schema: { name: 'Weight Loss Personal Training in Abu Dhabi' },
}

export default content
